import {
  AutoStoriesOutlined as AutoStoriesOutlinedIcon,
  EditNoteOutlined as EditNoteOutlinedIcon,
  FileUploadOutlined as FileUploadOutlinedIcon,
  InsightsRounded as InsightsRoundedIcon,
  MedicalServicesOutlined as TherapyPrepIcon,
  SchoolOutlined as SchoolOutlinedIcon,
} from '@mui/icons-material';
import { LOG_TYPES } from '../../../constants/logTypeRegistry';
import { getAdaptiveResponseQuickLogConfig } from './adaptiveQuickLogConfig';
import { getAdaptiveMedicationLogConfig } from './adaptiveMedicationLogConfig';

const buildAction = ({ id, label, description, logType, icon, handler }) => {
  const palette = logType?.palette || LOG_TYPES.log.palette;
  const IconComponent = icon || logType?.iconComponent || EditNoteOutlinedIcon;

  return {
    id,
    label,
    description,
    handler,
    icon: IconComponent,
    palette,
  };
};

export const STRUCTURED_TRACKING_GROUPS = [
  {
    id: 'insights',
    title: 'Insights',
    actions: [
      buildAction({
        id: 'custom-prepare',
        label: 'Prepare for a meeting or handover',
        description: 'Get the right information ready for an appointment, meeting, or care handover.',
        logType: LOG_TYPES.therapy,
        icon: AutoStoriesOutlinedIcon,
        handler: 'onOpenCustomPrepare',
      }),
      buildAction({
        id: 'iep-journey',
        label: 'Prepare for an IEP meeting',
        logType: LOG_TYPES.therapy,
        icon: SchoolOutlinedIcon,
        handler: 'onOpenIepJourney',
      }),
      buildAction({
        id: 'care-knowledge',
        label: 'Care Knowledge',
        logType: LOG_TYPES.health,
        icon: AutoStoriesOutlinedIcon,
        handler: 'onOpenCareKnowledge',
      }),
      buildAction({
        id: 'therapy-prep',
        label: 'Visit Prep',
        logType: LOG_TYPES.therapy,
        icon: TherapyPrepIcon,
        handler: 'onOpenTherapyPrep',
      }),
      buildAction({
        id: 'patterns-trends',
        label: 'Patterns & trends',
        description: 'See changes and connections over time.',
        logType: LOG_TYPES.health,
        icon: InsightsRoundedIcon,
        handler: 'onOpenInsights',
      }),
    ],
  },
  {
    id: 'daily-care',
    title: 'Daily Care',
    actions: [
      buildAction({ id: 'sleep', label: 'Sleep', logType: LOG_TYPES.sleep, handler: 'onOpenSleepLog' }),
      buildAction({ id: 'bathroom', label: 'Bathroom', logType: LOG_TYPES.bathroom, handler: 'onOpenBathroomLog' }),
      buildAction({ id: 'meals', label: 'Meals', logType: LOG_TYPES.food, handler: 'onOpenFoodLog' }),
    ],
  },
  {
    id: 'health',
    title: 'Health',
    actions: [
      buildAction({ id: 'medication', label: 'Medication', logType: LOG_TYPES.medication, handler: 'onOpenMedicalLog' }),
    ],
  },
  {
    id: 'support',
    title: 'Behavior',
    actions: [
      buildAction({ id: 'mood-responses', label: 'Response', logType: LOG_TYPES.behavior, handler: 'onOpenIncident' }),
    ],
  },
  {
    id: 'other',
    title: 'Other',
    actions: [
      buildAction({ id: 'custom-note', label: 'Custom note', logType: LOG_TYPES.log, handler: 'onOpenCustomNote' }),
      buildAction({ id: 'import-logs', label: 'Import past logs', logType: LOG_TYPES.log, icon: FileUploadOutlinedIcon, handler: 'onImportLogs' }),
    ],
  },
];

export const getStructuredTrackingGroups = (child) => {
  const responseConfig = getAdaptiveResponseQuickLogConfig(child);
  const medicationConfig = getAdaptiveMedicationLogConfig(child);

  return STRUCTURED_TRACKING_GROUPS.map((group) => {
    if (group.id === 'health') {
      return {
        ...group,
        actions: group.actions.map((action) => (
          action.handler === 'onOpenMedicalLog'
            ? { ...action, label: medicationConfig.title }
            : action
        )),
      };
    }

    if (group.id !== 'support') {
      return group;
    }

    return {
      ...group,
      title: responseConfig.timelineDisplayLabel,
      actions: group.actions.map((action) => (
        action.handler === 'onOpenIncident'
          ? { ...action, label: responseConfig.chipLabel }
          : action
      )),
    };
  });
};
